module.exports = __webpack_public_path__ + "ProximaNova-Light.0c08903bff9a0c621eab7a3ba53eeea6.woff";